import FileItem from '../fileitem';
import {
  DataList,
  DataListHeader,
  DataListHeaderCell,
  Spinner,
} from '../ui';

interface FileTableProps {
  files: Array<any>;
  groups: Array<any>;
  roles: Array<number>;
  view: string;
  loadingMoreFiles: boolean;
  showBlockingLoader: boolean;
  activeDownloadMenu: string | null;
  setActiveDownloadMenu: (id: string | null) => void;
  selectedItems: Array<number>;
  selectItem: (id: number) => void;
}

const FileTable = ({
  files,
  groups,
  roles,
  view,
  loadingMoreFiles,
  showBlockingLoader,
  activeDownloadMenu,
  setActiveDownloadMenu,
  selectedItems,
  selectItem,
}: FileTableProps) => (
  <DataList view={view}>
    {Array.isArray(files) && files.length > 0 && view === 'list' && (
      <DataListHeader>
        {(roles.includes(0) || roles.includes(1)) && (
          <div className="grid content-center flex-shrink-0 w-[50px]" />
        )}
        <DataListHeaderCell className="w-[60px]">Image</DataListHeaderCell>
        <DataListHeaderCell className="flex-grow min-w-[100px]">
          Name
        </DataListHeaderCell>
        {(roles.includes(0) || roles.includes(1)) && (
          <DataListHeaderCell className="w-[150px]">
            Permissions
          </DataListHeaderCell>
        )}
        <DataListHeaderCell className="w-[150px]">Date</DataListHeaderCell>
        <DataListHeaderCell className="w-[120px]">Size</DataListHeaderCell>
        <DataListHeaderCell className="w-[160px] border-r-0">
          Download
        </DataListHeaderCell>
      </DataListHeader>
    )}
    {Array.isArray(files) &&
      files.length > 0 &&
      files.map((item: any) => (
        <FileItem
          key={`file-${item.ID}`}
          id={`file-${item.ID}`}
          view={view}
          file={item}
          groups={groups}
          activeDownloadMenu={activeDownloadMenu}
          setActiveDownloadMenu={setActiveDownloadMenu}
          selectItem={selectItem}
          selectedItems={selectedItems}
        />
      ))}
    {loadingMoreFiles && !showBlockingLoader && (
      <div className="absolute top-0 left-0 grid items-center content-center w-full h-full bg-opacity-50 bg-shade">
        <div className="text-center ">
          <Spinner className="w-[30px] h-[30px] absolute bottom-12 mx-auto" />
        </div>
      </div>
    )}
  </DataList>
);

export default FileTable;
